(function (root, factory) {
  'use strict';
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.MMConfiguratorModel = factory();
}(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  var OPTION_COUNT = 3;

  function nonempty(value) {
    return typeof value === 'string' && value.length > 0;
  }

  function validState(state) {
    return Array.isArray(state) && state.length === OPTION_COUNT &&
      state.every(function (value) { return typeof value === 'string'; });
  }

  function complete(state) {
    return validState(state) && state.every(nonempty);
  }

  function buildCatalog(raw) {
    if (!raw || !Array.isArray(raw.options) || raw.options.length !== OPTION_COUNT ||
        !Array.isArray(raw.variants)) {
      throw new TypeError('Catalog requires three options and a variants array');
    }
    var names = new Set();
    var options = raw.options.map(function (option) {
      if (!option || !nonempty(option.name) || names.has(option.name) ||
          !Array.isArray(option.values) || !option.values.every(nonempty) ||
          new Set(option.values).size !== option.values.length) {
        throw new TypeError('Catalog option names and values must be unique nonempty strings');
      }
      names.add(option.name);
      return { name: option.name, values: option.values.slice() };
    });
    var byId = new Map();
    var byKey = new Map();
    var variants = raw.variants.map(function (variant) {
      if (!variant || typeof variant.id !== 'string' || !/^\d+$/.test(variant.id) ||
          !complete(variant.options) || !variant.options.every(function (value, index) {
            return options[index].values.indexOf(value) !== -1;
          })) {
        throw new TypeError('Variant requires a numeric string id and three known option values');
      }
      var key = JSON.stringify(variant.options);
      if (byId.has(variant.id)) throw new Error('Duplicate variant id: ' + variant.id);
      if (byKey.has(key)) throw new Error('Duplicate variant combination: ' + key);
      var copy = Object.assign({}, variant, { options: variant.options.slice() });
      byId.set(copy.id, copy);
      byKey.set(key, copy);
      return copy;
    });
    return { productId: raw.productId, options: options, variants: variants, byId: byId, byKey: byKey };
  }

  function emptyState() {
    return ['', '', ''];
  }

  // Inventory is deliberately not a filter: selection and purchase readiness are separate.
  function allowedValues(catalog, state, index) {
    if (!Number.isInteger(index) || index < 0 || index >= OPTION_COUNT || !validState(state)) return [];
    var prefix = state.slice(0, index);
    if (!prefix.every(nonempty)) return [];
    var matching = new Set();
    catalog.variants.forEach(function (variant) {
      if (prefix.every(function (value, earlier) { return variant.options[earlier] === value; })) {
        matching.add(variant.options[index]);
      }
    });
    return catalog.options[index].values.filter(function (value) { return matching.has(value); });
  }

  function select(catalog, state, index, value) {
    var next = validState(state) ? state.slice() : emptyState();
    if (!Number.isInteger(index) || index < 0 || index >= OPTION_COUNT ||
        !next.slice(0, index).every(nonempty)) return next;
    if (value !== '' && allowedValues(catalog, next, index).indexOf(value) === -1) return next;
    next[index] = value;
    for (var later = index + 1; later < OPTION_COUNT; later += 1) {
      if (allowedValues(catalog, next, later).indexOf(next[later]) === -1) next[later] = '';
    }
    return next;
  }

  function exactVariant(catalog, state) {
    if (!complete(state)) return null;
    return catalog.byKey.get(JSON.stringify(state)) || null;
  }

  function designName(state) {
    return complete(state) ? state.join(' / ') : '';
  }

  function previewKey(state) {
    if (!validState(state) || !nonempty(state[0]) || !nonempty(state[1])) return null;
    return JSON.stringify(state.slice(0, nonempty(state[2]) ? OPTION_COUNT : 2));
  }

  return {
    buildCatalog: buildCatalog,
    emptyState: emptyState,
    select: select,
    exactVariant: exactVariant,
    allowedValues: allowedValues,
    designName: designName,
    previewKey: previewKey
  };
}));
